import { SourceAPI } from '../../sources/api/SourceAPI';
import { DestinationAPI } from '../../destinations/api/DestinationAPI';

export const sourceNameValidator = async (value: string, signal: AbortSignal) => {
  return SourceAPI.validateSourceName(value, { signal }).then(res => ({
    isValid: res.data.valid,
    reason: res.data.reason
  }));
};

export const destinationNameValidator = async (value: string, signal: AbortSignal) => {
  return DestinationAPI.validateDestinationName(value, { signal }).then(res => ({
    isValid: res.data.valid,
    reason: res.data.reason
  }));
};
